export default __webpack_public_path__ + "static/media/STL-postal-ballot-notice-15.10.2026.70b098c2.pdf";